import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../BASEURL";
import EnquiryList from "../contact/EnquiryList";

export default function Dashboard() {
  const navigate = useNavigate();
  const [productCount, setProductCount] = React.useState(null);
  const [galleryCount, setGalleryCount] = React.useState(null);
  const [testimonialCount, setTestimonialCount] = React.useState(null);
  const [inquiryCount, setInquiryCount] = React.useState(null);

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      navigate("/admin/login");
    }
    // Fetch product count
    const fetchProductCount = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/product/total/count`);
        const result = await res.json();
        setProductCount(result.total || 0);
      } catch (e) {
        setProductCount(0);
      }
    };
    // Fetch gallery count
    const fetchGalleryCount = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/gallery/total/count`);
        const result = await res.json();
        setGalleryCount(result.total || 0);
      } catch (e) {
        setGalleryCount(0);
      }
    };
    // Fetch testimonial count
    const fetchTestimonialCount = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/testimonial/total/count`);
        const result = await res.json();
        setTestimonialCount(result.total || 0);
      } catch (e) {
        setTestimonialCount(0);
      }
    };
    // Fetch inquiry count
    const fetchInquiryCount = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/inquiry/total/count`);
        const result = await res.json();
        setInquiryCount(result.total || 0);
      } catch (e) {
        setInquiryCount(0);
      }
    };
    fetchProductCount();
    fetchGalleryCount();
    fetchTestimonialCount();
    fetchInquiryCount();
  }, [navigate]);

  const cards = [
    { title: "Products", value: productCount === null ? "..." : productCount },
    { title: "Gallery Images", value: galleryCount === null ? "..." : galleryCount },
    { title: "Testimonials", value: testimonialCount === null ? "..." : testimonialCount },
    { title: "Inquiries", value: inquiryCount === null ? "..." : inquiryCount },
  ];

  return (
    <>
      <h2 className="text-2xl font-heading text-primaryDark font-bold mb-6">Dashboard</h2>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        {cards.map((card, i) => (
          <div
            key={i}
            className="bg-white p-6 rounded-xl shadow-sm"
          >
            <h4 className="text-textGray font-bold text-sm">{card.title}</h4>
            <p className="text-3xl font-bold text-primary mt-2">
              {card.value}
            </p>
          </div>
        ))}
      </div>

       <EnquiryList />
    </>
  );
}
